var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily-separator"},[_c('div',{staticClass:"text f-medium"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.message.created_at,'YYYY년 M월 D일'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }